module.exports = __webpack_public_path__ + "img/icon4.f9faf95a.svg";